export { default } from './DuvidasFrequentes';
